import { render, staticRenderFns } from "./TreeIndex.vue?vue&type=template&id=1304f80a&scoped=true&"
import script from "./TreeIndex.vue?vue&type=script&lang=js&"
export * from "./TreeIndex.vue?vue&type=script&lang=js&"
import style0 from "./TreeIndex.vue?vue&type=style&index=0&id=1304f80a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304f80a",
  null
  
)

export default component.exports